import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "@/App";
import { SessionProvider } from "@/session";
import "@/theme.css";

/* Without this, a throw in any screen unmounts the whole tree and the page goes white --
   no message, nothing in the UI to act on. A class is the only way to catch a render
   error; React ships no hook for it. */
class Boundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeContent: "center",
          justifyItems: "center",
          gap: "14px",
          padding: "32px",
          textAlign: "center",
        }}
      >
        <p style={{ font: "var(--text-title)", color: "var(--text-primary)", margin: 0 }}>
          This screen failed to load.
        </p>
        <p
          style={{
            font: "var(--text-body-14)",
            color: "var(--text-muted)",
            margin: 0,
            maxWidth: "44ch",
          }}
        >
          The details are in the browser console. Reloading usually clears it; if it keeps
          happening, the message there is what to report.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            font: "var(--text-label)",
            color: "var(--btn-primary-ink)",
            background: "var(--btn-primary-bg)",
            border: "none",
            borderRadius: "var(--radius-btn)",
            padding: "10px 18px",
            cursor: "pointer",
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Boundary>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </Boundary>
  </React.StrictMode>,
);
